import { render, staticRenderFns } from "./CardAvgBuyIn.vue?vue&type=template&id=797eb74c&scoped=true"
import script from "./CardAvgBuyIn.js?vue&type=script&lang=js&external"
export * from "./CardAvgBuyIn.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797eb74c",
  null
  
)

export default component.exports